import { Box, Button, Checkbox, Radio, Text, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { Assign } from './Assign'

import { useNavigate } from 'react-router-dom'

import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ViewFormFunc } from '../Redux/Form/ViewForm'
import { ViewMySubmissionFunc } from '../Redux/Form/ViewMySubmission'
import { SubmitFormFunc } from '../Redux/Form/SubmitForm'


export const ViewForm = () => {
    const view = useSelector((state) => state.view.data)
    const role = useSelector((state) => state?.user?.userData?.userInfo?.userDetailsDto?.role);
    const ViewMySubmission = useSelector((state) => state.ViewMySubmission.data)
    console.log(ViewMySubmission)
    const Id = useParams()
    const dispatch = useDispatch()
    const orgId = useSelector((state) => state.user.orgId);
    const toast = useToast()

    console.log("FormId param", Id)

    console.log("View form page", view, role)

    const [Selected, setSelected] = useState([])

    const handleCheckboxChange = (questionId, optionText, isChecked) => {
        console.log("isChecked", isChecked)
        if (isChecked) {
            setSelected((prevSelected) => [...prevSelected, { questionId, optionText }]);
        } else {
            setSelected((prevSelected) =>
                prevSelected.filter((el) => !(el.questionId === questionId && el.optionText === optionText))
            );
        }
    };
    
    const handleRadioChange = (questionId, optionText) => {
        const filteredSelected = Selected.filter((el) => el.questionId !== questionId);
        setSelected([...filteredSelected, { questionId, optionText }])
    };
    


    console.log(Selected)

    const { isOpen, onOpen, onClose } = useDisclosure();

    const navigate = useNavigate()

    const userId = useSelector((state) => state.user.userData.userId);


    useEffect(() => {


        if (role === "ADMIN") {

            dispatch(ViewFormFunc(Id.formId, userId))
        }
        else {
            dispatch(ViewMySubmissionFunc(Id.formId, userId))

        }



    }, [Id.formId, userId])



    const handleSubmitForm = () => {
        dispatch(SubmitFormFunc(Id.formId, Selected, userId)).then((res) => {
            console.log(res.data)
            if (res.payload.data == "Form submitted successfully!") {
                toast({
                    title: `Form Submitted Succesfully`,
                    status: "success",
                    position: "top",
                    duration: 2000,
                    isClosable: true,
                  })
                navigate(`/myforms?orgId=${orgId}`)
            }
        })
    }


    return (
        <Box   >
            <Text align={"center"} fontSize="40px" fontWeight={"bold"} pt="15px"  >{(role === "ADMIN" ? view : ViewMySubmission).formTitle}</Text>

            <Box>

                <Box display={"flex"} flexDir="column" justifyContent={"center"} w={{lg:"60%"}} m="auto" p={5} >
                    {(role === "ADMIN" ? view : ViewMySubmission).questions?.map((el, i) => {
                        return (
                            <Box key={i} mt="5" pl="15" p="8" rounded="xl" backgroundColor={"#faf3fe"}>
                                <Text fontSize="20px" lineHeight={8} >{i + 1}.{"  "}  {el.questionText} ?    </Text>
                                {el.questionType == "MCQ" && <Box display={{lg:"flex"}} gap="5">
                                    {el.optionsStrings?.map((option, i) => {

                                    const isChecked = Selected.some((el) => el.questionId === el.questionId && el.optionText === option);

                                        {
                                            if (ViewMySubmission.status == "UNFILLED") {
                                                return <Checkbox size={"lg"} ml={2} mt="5" key={i} onChange={(e) => handleCheckboxChange(el.questionId, option, e.target.checked)} isChecked={isChecked}  >{option}</Checkbox>
                                            }
                                            else {
                                                const isChecked = option === el.selectedOption


                                                return <Checkbox size={"lg"} mt="5" isChecked={isChecked} key={i} isDisabled="true"  >{option}</Checkbox>
                                            }
                                        }

                                    })}
                                </Box>}
                                {el.questionType == "YES_NO" && <Box display={{lg:"flex"}} gap="5">
                                    {el.optionsStrings?.map((option, i) => {

                                        const isChecked = Selected.some((el) => el.questionId === el.questionId && el.optionText === option);
                                        {
                                            if (ViewMySubmission.status == "UNFILLED") {
                                                return <Radio size={"lg"} ml={3} mt="5" key={i} value={option === el.selected} isChecked={isChecked} onChange={() => handleRadioChange(el.questionId, option)} >{option}</Radio>
                                            }
                                            else {
                                                const value = option === el.selectedOption
                                                return <Radio size={"lg"} mt="5" value={value} isChecked={value} key={i} isDisabled="true">{option}</Radio>
                                            }
                                        }

                                    })}
                                </Box>}
                            </Box>
                        )
                    })}
                </Box>
            </Box>
            <Box display={"flex"} justifyContent={"center"} mt="5" >

                {
                    ((role === "ADMIN" ? view : ViewMySubmission).status == "UNFILLED" && role == "ADMIN")
                        ?
                        <Box display={"flex"} gap="5">
                            <Button colorScheme='blue' onClick={() => onOpen()}>Assign</Button>
                            {<Assign isOpen={isOpen} onClose={onClose} />}
                            <Button colorScheme='blue' onClick={() => navigate(`/createform?orgId=${orgId}`)}>Back</Button>
                        </Box>
                        :
                        null
                }
                {
                    ((role === "ADMIN" ? view : ViewMySubmission).status == "UNFILLED" && role == "USER") ?
                        <Box display={"flex"} gap="5">
                            <Button colorScheme='blue' onClick={handleSubmitForm}>Submit Form</Button>
                            <Button colorScheme='blue' onClick={() => navigate(`/dashboard?orgId=${orgId}`)}>Home</Button>

                        </Box>
                        :
                        null
                }

            </Box>
        </Box>
    )
}
